export default {
  '_b._qhyy': 'Changer de langue',

  '_a._jzz': 'Chargement...',
  '_a._jzgd': 'Charger plus',
  '_a._wct': 'Bienvenue sur',
  '_a._gd': 'Plus',
  '_a._bf': 'Lire',
  '_a._bcz': 'Sauvegarde...',
  '_a._sctp': 'Télécharger une image',

  '_dl._qssyx': 'Veuillez saisir votre email',
  '_dl._qssmm': 'Veuillez saisir votre mot de passe',
  '_dl._ann': 'Se connecter',
  '_dl._hmyzh': "Vous n'avez pas de compte ?",
  '_dl._qzc': "S'inscrire",
  '_dl._yzhl': 'Vous avez déjà un compte ?',
  '_dl._qdl': 'Se connecter',
  '_dl._srqrmm': 'Veuillez confirmer votre mot de passe',
  '_dl._sryqm': "Veuillez saisir le code d'invitation",
  '_dl._sryzm': 'Veuillez saisir le code de vérification',
  '_dl._ljzc': "S'inscrire maintenant",
  '_dl._zcbsty': "L'inscription signifie que vous avez lu et accepté la",
  '_dl._yszc': 'Politique de Confidentialité',
  '_dl._lcmmbyy': 'Les mots de passe ne correspondent pas',

  '_yzm._fsyzm': 'Envoyer le code de vérification',
  '_yzm._cxfs': '({time}) Renvoyer',
  '_yzm._fsz': 'Envoi en cours...',
  '_yzm._fscg': 'Envoyé avec succès',

  '_h._zrm': 'Le plus populaire',
  '_h._zxd': 'Le plus récent',
  '_h._phb': 'Classement',
  '_h._qz': "Fonds d'écran",
  '_h._ssww': 'Rechercher',
  '_h._lsjl': 'Historique',
  '_h._gd': 'Plus',
  '_h._dl': 'Se connecter',
  '_h._ye': 'Solde',
  '_h._dj': 'Gelé',
  '_h._ybp': 'Tableau de bord',
  '_h._wdqb': 'Mon portefeuille',
  '_h._scjl': 'Favoris',
  '_h._xxzx': 'Centre de messages',
  '_h._fxhy': 'Partager avec des amis',
  '_h._bzzx': "Centre d'aide",
  '_h._ggtf': 'Placement publicitaire',
  '_h._bqtz': "Investissement en droits d'auteur",
  '_h._sz': 'Paramètres',

  '_sy._jx': 'Sélectionnés',
  '_sy._xpfb': 'Nouvelles sorties',
  '_sy._gdsp': 'Plus de vidéos',

  '_qz._jbqz': "Collection de fonds d'écran exquis",
  '_qz._ssqz': "Rechercher un fond d'écran",
  '_qz._qb': 'Tous',
  '_qz._zrfg': 'Paysages naturels',
  '_qz._cxys': 'Art abstrait',
  '_qz._csjz': 'Architecture urbaine',
  '_qz._dmyx': 'Animé et jeux',
  '_qz._yzxk': 'Cosmos et étoiles',
  '_qz._yl': 'Aperçu',
  '_qz._xzqz': "Télécharger le fond d'écran",
  '_qz._fbl': 'Résolution',
  '_qz._fl': 'Catégorie',
  '_qz._jzz': 'Chargement',
  '_qz._myzdpp': "Aucun fond d'écran correspondant trouvé",

  '_sp._xyjscl': 'Déverrouillage requis pour regarder',
  '_sp._cz': 'Recharger',
  '_sp._jsqj': 'Déverrouiller tous les épisodes',
  '_sp._jsbj': 'Déverrouiller cet épisode',
  '_sp._sc': 'Favori',
  '_sp._fx': 'Partager',
  '_sp._jsqjjs': 'Confirmer le paiement de {a} pour déverrouiller tous les épisodes ?',
  '_sp._jsbjjs': 'Confirmer le paiement de {a} pour déverrouiller cet épisode ?',
  '_sp._zfz': 'Traitement du paiement...',
  '_sp._qrzf': 'Confirmer le paiement',
  '_sp._qx': 'Annuler',

  '_qz._smrc': 'Lever de soleil montagnard',
  '_qz._cxjh': 'Géométrie abstraite',
  '_qz._dsyj': 'Paysage nocturne urbain',
  '_qz._dmfj': 'Paysage animé',
  '_qz._hhxk': 'Ciel étoilé vaste',
  '_qz._slmw': 'Brouillard forestier',
  '_qz._scld': 'Flux de couleurs',
  '_qz._xdjz': 'Architecture moderne',

  '_qb._cbjl': 'Historique des dépôts',
  '_qb._jyjl': 'Historique des transactions',
  '_qb._bddz': 'Adresses liées',
  '_qb._txjl': 'Historique des retraits',

  '_m._tcdl': 'Se déconnecter',
  '_m._cb': 'Déposer',
  '_m._tb': 'Retirer',

  '_cb._ssdz': 'Rechercher une devise ou une adresse',
  '_cb._bz': 'Devise',
  '_cb._je': 'Montant',
  '_cb._dz': 'Adresse',
  '_cb._sj': 'Heure',
  '_cb._cz': 'Action',
  '_cb._zwjl': 'Aucun historique de transaction pour le moment',
  '_cb._dny': 'Page {a} sur {b}',
  '_cb._jyxq': 'Détails de la transaction',
  '_cb._jydz': 'Adresse de la transaction',
  '_cb._zt': 'Statut',
  '_cb._yqr': 'Confirmé',
  '_cb._qb': 'Tous',
  '_cb._jt': "Aujourd'hui",
  '_cb._j7t': '7 derniers jours',
  '_cb._j30t': '30 derniers jours',
  '_cb._zw': 'Aucun',
  '_cb._fzcg': 'Adresse copiée dans le presse-papiers',

  '_jyjl._ssdz': 'Rechercher une devise ou une adresse',
  '_jyjl._lx': 'Type',
  '_jyjl._je': 'Montant',
  '_jyjl._ye': 'Solde',
  '_jyjl._dj': 'Gelé',
  '_jyjl._sj': 'Heure',
  '_jyjl._cz': 'Action',
  '_jyjl._zwjyjl': 'Aucun historique de transaction pour le moment',
  '_jyjl._czsx': 'Réinitialiser le filtre',
  '_jyjl._dny': 'Page {a} sur {b}',
  '_jyjl._jyxq': 'Détails de la transaction',
  '_jyjl._jylx': 'Type de transaction',
  '_jyjl._jyje': 'Montant de la transaction',
  '_jyjl._jyhye': 'Solde après transaction',
  '_jyjl._djye': 'Montant gelé',
  '_jyjl._jysj': 'Heure de la transaction',
  '_jyjl._jyzt': 'Statut de la transaction',
  '_jyjl._ywc': 'Terminé',
  '_jyjl._qb': 'Tous',
  '_jyjl._jt': "Aujourd'hui",
  '_jyjl._j7t': '7 derniers jours',
  '_jyjl._j30t': '30 derniers jours',

  '_jyjl._tp1': 'Dépôt',
  '_jyjl._tp2': 'Retrait',
  '_jyjl._tp3': 'Paiement',
  '_jyjl._tp4': 'Dépôt',
  '_jyjl._tp5': 'Geler',
  '_jyjl._tp6': 'Revenus',
  '_jyjl._tp7': 'Récompense de parrainage',
  '_jyjl._tp8': 'Récompense de connexion',
  '_jyjl._tp9': 'Revenus de promotion',
  '_jyjl._tp10': 'Récompense vidéo',
  '_jyjl._tp11': "Bonus d'inscription",
  '_jyjl._tp12': 'Retrait refusé',
  '_jyjl._tp13': 'Enveloppe rouge',

  '_jyjl._tp14': 'Transfert interne',

  '_cb._shz': "En cours d'examen",
  '_cb._yyg': 'Approuvé',
  '_cb._ybh': 'Rejeté',

  '_bddz._tjdz': 'Ajouter une adresse',
  '_bddz._ssdz': 'Rechercher une adresse',
  '_bddz._bz': 'Devise',
  '_bddz._dz': 'Adresse',
  '_bddz._sysj': 'Dernière utilisation',
  '_bddz._cz': 'Action',
  '_bddz._zwjl': 'Aucune adresse enregistrée pour le moment',
  '_bddz._dny': 'Page {a} sur {b}',
  '_bddz._dzewm': "Code QR de l'adresse",
  '_bddz._fzdz': "Copier l'adresse",
  '_bddz._dzxq': "Détails de l'adresse",
  '_bddz._wl': 'Réseau',
  '_bddz._tjsj': "Date d'ajout",
  '_bddz._bzwa': 'Note',
  '_bddz._ntq': 'Il y a {a} jours',
  '_bddz._nxsq': 'Il y a {a} heures',
  '_bddz._nfzq': 'Il y a {a} minutes',
  '_bddz._ngg': "À l'instant",
  '_bddz._dzyfz': 'Adresse copiée dans le presse-papiers',
  '_bddz._scqr': 'Confirmation de suppression',
  '_bddz._scqrdz': 'Êtes-vous sûr de vouloir supprimer cette adresse ?',
  '_bddz._qr': 'Confirmer',
  '_bddz._qx': 'Annuler',
  '_bddz._scdzcg': 'Adresse supprimée avec succès',

  '_txjl._ztsx': 'Filtre par statut',
  '_txjl._qbzt': 'Tous les statuts',
  '_txjl._shz': "En cours d'examen",
  '_txjl._ytg': 'Approuvé',
  '_txjl._yjj': 'Rejeté',
  '_txjl._ssdz': 'Rechercher une adresse ou un montant',
  '_txjl._bz': 'Devise',
  '_txjl._je': 'Montant',
  '_txjl._dz': 'Adresse',
  '_txjl._zt': 'Statut',
  '_txjl._sj': 'Heure',
  '_txjl._cz': 'Action',
  '_txjl._zwjl': 'Aucun historique de transaction pour le moment',
  '_txjl._czsx': 'Réinitialiser le filtre',
  '_txjl._dny': 'Page {a} sur {b}',
  '_txjl._jyxq': 'Détails de la transaction',
  '_txjl._skdz': 'Adresse de réception',
  '_txjl._jysj': 'Heure de la transaction',
  '_txjl._jyzt': 'Statut de la transaction',
  '_txjl._fzdz': 'Adresse copiée dans le presse-papiers',

  '_cbsq._bz': 'Devise',
  '_cbsq._wl': 'Réseau',
  '_cbsq._erwm': 'Code QR',
  '_cbsq._fzdz': "Copier l'adresse",

  '_txsq._bz': 'Devise',
  '_txsq._wl': 'Réseau',
  '_txsq._ye': 'Solde',
  '_txsq._sxf': 'Frais',
  '_txsq._zxtx': 'Retrait minimum',
  '_txsq._txdz': 'Adresse de retrait',
  '_txsq._qxztxdz': "Veuillez sélectionner l'adresse de retrait",
  '_txsq._txje': 'Montant du retrait',
  '_txsq._qsrtxje': 'Veuillez saisir le montant du retrait',
  '_txsq._yxyzm': 'Code de vérification par email',
  '_txsq._qsryxyzm': 'Veuillez saisir le code de vérification',
  '_txsq._ljtx': 'Retirer maintenant',

  '_jl._wxhd': 'Mes favoris',
  '_jl._lsjl': 'Historique',

  '_xx._bt': 'Centre de messages',
  '_xx._wjl': 'Aucun enregistrement',
  '_xx._zsmyxx': 'Aucun message pour le moment',
  '_xx._sxxx': 'Actualiser les messages',
  '_xx._sxcg': 'Actualisé avec succès',

  '_fx._fxhy': 'Partager avec des amis',
  '_fx._smfx': 'Scannez le code QR pour partager avec des amis',
  '_fx._jlsm': 'Description de la récompense',
  '_fx._jlsm1': '1. Les amis que vous invitez directement (Niveau 1) vous accordent {a}% de leurs revenus.',
  '_fx._jlsm2': '2. Les amis invités par vos amis de Niveau 1 (Niveau 2) vous accordent {a}% de leurs revenus.',
  '_fx._jlsm3': '3. Les amis invités par vos amis de Niveau 2 (Niveau 3) vous accordent {a}% de leurs revenus.',
  '_fx._fzlj': 'Copier le lien',

  '_bzzx._bzzx': "Centre d'aide",
  '_bzzx._rhzczh': 'Comment créer un compte',
  '_bzzx._zclc': "Processus d'inscription",
  '_bzzx._rhzcxyh': 'Comment créer un nouveau compte ?',
  '_bzzx._rhzcxyh1': 'Cliquez sur le bouton "S\'inscrire", saisissez votre adresse email, définissez un mot de passe et complétez la vérification email pour créer un compte.',
  '_bzzx._rhcz': 'Comment recharger ?',
  '_bzzx._rhcz1': 'Processus de recharge',
  '_bzzx._rhcz2': 'Instructions détaillées de recharge',
  '_bzzx._rhcz3': "Cliquez sur Mon Portefeuille, Déposer, sélectionnez la cryptomonnaie souhaitée et envoyez vers l'adresse fournie.",

  '_bzzx._rhjsdj': 'Comment déverrouiller un mini-drama',
  '_bzzx._rhjsdj2': 'Cliquez pour déverrouiller des épisodes individuels et voir plus de contenu.',

  '_bzzx._rhtx': 'Comment retirer de son compte',
  '_bzzx._rhtx1': '1. Allez dans Mon Portefeuille, Adresses de retrait, ajoutez une nouvelle adresse pour la cryptomonnaie correspondante.<br>2. Cliquez sur Retirer, sélectionnez la cryptomonnaie, choisissez une adresse liée, saisissez le montant et attendez la réception.',

  '_bzzx._qtwt': 'Autres questions',
  '_bzzx._qtwt1': 'Comment contacter le service client ?',
  '_bzzx._qtwt2': 'Vous pouvez nous contacter via le service client en ligne en bas à droite du site, par email ou par téléphone.',
  '_bzzx._myzdwt': "Vous n'avez pas trouvé la réponse ?",
  '_bzzx._khjybbzn': 'Notre équipe est ravie de vous aider.',
  '_bzzx._lxkf': 'Contacter le service client',

  '_ggtf._bt1': 'Placement publicitaire',
  '_ggtf._splb': 'Liste des vidéos',
  '_ggtf._wcyd': 'Ma participation',
  '_ggtf._hdbm': "Code de l'événement",
  '_ggtf._tian': 'Jours',
  '_ggtf._kssj': 'Heure de début',
  '_ggtf._jssj': 'Heure de fin',
  '_ggtf._ddvp': 'Atteindre le niveau VIP {a}, moyenne de {b} participations par personne',
  '_ggtf._hdzt': "Statut de l'événement",
  '_ggtf._wks': 'Non commencé',
  '_ggtf._ycy': 'Participé',
  '_ggtf._qg': 'Acheter maintenant',
  '_ggtf._mygdl': 'Plus de données',
  '_ggtf._qgrtd': "Trop d'acheteurs, veuillez réessayer",
  '_ggtf._hdxq': "Détails de l'événement",
  '_ggtf._hdjs': "Description de l'événement",
  '_ggtf._cyyq': 'Conditions de participation',
  '_ggtf._zdtz': 'Investissement minimum',
  '_ggtf._vpdj': 'Niveau VIP',
  '_ggtf._rjcy': 'Participation moyenne',
  '_ggtf._gmje': "Montant d'achat",
  '_ggtf._qsrgmje': "Veuillez saisir le montant d'achat",
  '_ggtf._qx': 'Annuler',
  '_ggtf._ljcy': 'Participer maintenant',
  '_ggtf._ssjymm': 'Saisir le mot de passe de transaction',
  '_ggtf._qssjymm': 'Veuillez saisir le mot de passe de transaction',
  '_ggtf._ji': 'Niveau',
  '_ggtf._ci': 'fois',
  '_ggtf._zdgm': "Montant d'achat minimum",
  '_ggtf._zggm': "Montant d'achat maximum",
  '_ggtf._zfz': 'Traitement du paiement...',

  '_wdtg._wjl': 'Aucun historique de participation',
  '_wdtg._tzje': 'Montant investi',
  '_wdtg._zsy': 'Revenus totaux',
  '_wdtg._hdts': "Jours de l'événement",
  '_wdtg._cysj': 'Heure de participation',
  '_wdtg._qzf': 'Aller payer',
  '_wdtg._jxz': 'En cours',
  '_wdtg._djszje': 'Montant total en attente',
  '_wdtg._gjb': 'Total de {a} éléments',
  '_wdtg._djs': 'En attente de règlement',
  '_wdtg._zrsy': "Revenus d'hier",
  '_wdtg._dbl': 'Lectures à la demande',
  '_wdtg._bfl': 'Nombre de lectures',
  '_wdtg._wdsy': 'Mes revenus',
  '_wdtg._bqffc': "Part des droits d'auteur",
  '_wdtg._mr0djs': "Revenus d'hier réglés quotidiennement à 00:00",
  '_wdtg._jrsy': "Revenus aujourd'hui",
  '_wdtg._mygd': 'Plus de données',

  '_bqyy._bqyy': 'Rendez-vous pour collaboration',
  '_bqyy._qrbq': 'Confirmer la demande de rendez-vous ?',
  '_bqyy._qx': 'Annuler',
  '_bqyy._tjyy': 'Soumettre le rendez-vous',

  '_bqyy._spsq': 'Demande de collaboration vidéo',
  '_bqyy._spsy': 'Promouvoir des vidéos ensemble pour plus de trafic et de revenus !',
  '_bqyy._ljyy': 'Réserver maintenant',
  '_bqyy._sphz': "Qu'est-ce que la collaboration vidéo ?",
  '_bqyy._sphzsm': 'La collaboration vidéo offre plus de visibilité mutuellement bénéfique. Obtenez reconnaissance et opportunités de collaboration.',
  '_bqyy._sqhch': 'Avantages de la collaboration',
  '_bqyy._llfz': 'Soutien du trafic',
  '_bqyy._llfzsm': 'Augmentez votre visibilité et vos lectures.',
  '_bqyy._sytg': 'Revenus accrus',
  '_bqyy._sytgsm': 'Bénéficiez de meilleurs revenus publicitaires.',
  '_bqyy._yxhz': 'Collaboration prioritaire',
  '_bqyy._yxhzsm': 'Participez en priorité aux événements officiels.',
  '_bqyy._yytj': 'Conditions de rendez-vous',
  '_bqyy._sptg': 'Exigences de promotion',
  '_bqyy._sptgsm': 'Participez à au moins 1 promotion vidéo.',
  '_bqyy._yysm': 'Notre équipe vous contactera sous 3 jours.',

  '_ybp._wdsy': 'Mes revenus',
  '_ybp._dqye': 'Solde actuel',
  '_ybp._jr': "Aujourd'hui",
  '_ybp._jrzsy': "Revenus totaux aujourd'hui",
  '_ybp._ljzsy': 'Revenus totaux cumulés',
  '_ybp._tgfh': 'Dividendes de promotion',
  '_ybp._ljsy': 'Revenus cumulés',
  '_ybp._bqsy': "Revenus des droits d'auteur",
  '_ybp._yqfh': 'Dividendes de parrainage',
  '_ybp._mrsy': 'Revenus quotidiens',
  '_ybp._tgsy': 'Revenus de promotion',

  '_tjdz._tjxd': 'Ajouter une adresse',
  '_tjdz._xzbz': 'Sélectionner une devise',
  '_tjdz._qbdz': 'Adresse du portefeuille',
  '_tjdz._srdz': "Veuillez saisir l'adresse",
  '_tjdz._qx': 'Annuler',
  '_tjdz._bc': 'Sauvegarder',

  '_sz._smrz': "Vérification d'identité",
  '_sz._rzlx': 'Type de vérification',
  '_sz._sfzzm': "Recto de la pièce d'identité",
  '_sz._sfzfm': "Verso de la pièce d'identité",
  '_sz._zsxm': 'Nom réel',
  '_sz._qsrzsxm': 'Veuillez saisir votre nom',
  '_sz._sfzhm': "Numéro de pièce d'identité",
  '_sz._qsrsfzhm': 'Veuillez saisir le numéro',
  '_sz._yyzz': 'Registre du commerce',
  '_sz._qymc': "Nom de l'entreprise",
  '_sz._yyzzh': "Numéro d'enregistrement",
  '_sz._qsrqymc': 'Veuillez saisir le nom',
  '_sz._qsryyzzh': 'Veuillez saisir le numéro',
  '_sz._qx': 'Annuler',
  '_sz._tjrz': 'Soumettre la vérification',
  '_sz._zt': 'Statut',
  '_sz._gr': 'Individuel',
  '_sz._qy': 'Entreprise',
  '_sz._shz': 'En examen',
  '_sz._ytg': 'Approuvé',
  '_sz._ybh': 'Rejeté',

  '_mm._xgmm': 'Changer le mot de passe',
  '_mm._dqxg': 'Changez votre mot de passe régulièrement',
  '_mm._dqmm': 'Mot de passe actuel',
  '_mm._xmm': 'Nouveau mot de passe',
  '_mm._qrxmm': 'Confirmer le nouveau mot de passe',
  '_mm._qx': 'Annuler',
  '_mm._qrxg': 'Confirmer le changement',

  '_jymm._xgjymm': 'Changer le mot de passe de transaction',

  '_szzx._sz': 'Paramètres',
  '_szzx._yrz': 'Vérifié',
  '_szzx._wrz': 'Non vérifié',
  '_szzx._jymm': 'Mot de passe de transaction',
  '_szzx._szjymm': 'Définir ou modifier le mot de passe',
  '_szzx._tcdl': 'Se déconnecter',
  '_szzx._qdtcdl': 'Êtes-vous sûr de vouloir vous déconnecter ?',
  '_szzx._qrtc': 'Confirmer la déconnexion',
  '_szzx._qx': 'Annuler',

  '_yj._gy': 'À propos',

  '_yj._lxwm': 'Nous contacter',

  '_yj._yszc': 'Politique de confidentialité',

  '_yj._yhxy': "Conditions d'utilisation",

  '_cd._gszz': "Qualifications de l'entreprise",

  '_cd._wmyy': 'Nous possédons toutes les qualifications et certifications requises par le secteur, garantissant à nos utilisateurs des services vidéo légaux, sécurisés et de haute qualité',

  '_cd._yyzz': "Preuve valable de l'activité légale de l'entreprise, attestant de notre inscription officielle et de notre champ d'activité",

  '_cd._yyzz2': "Licence d'exploitation certifiée, obtenue légalement, garantissant la légalité et la conformité de la plateforme",

  '_bz._lxkf': "Cliquez ci-dessous pour contacter le service client, ou contactez-nous par e-mail ou ligne d'assistance téléphonique",

  '_sz._bjtx': 'Modifier',

  '_sz._bjxx': 'Modifier le message',

  '_sz._tx': 'Avatar',

  '_sz._bcun': 'Enregistrer',

  '_db._zskf': 'Contacter le support',
  '_db._zsry': 'Conseiller dédié',
  '_db._wdq': 'Non lu',
  '_db._ydq': 'Lu',

  '_sc._sctp': 'Télécharger une image',
  '_sc._xztp': 'Choisir une image',
  '_sc._fstp': "Envoyer l'image",
  '_sc._qx': 'Annuler',
  '_sc._hd': "D'accord",

  '_zcyl._zcbt': "Cadeau d'inscription",
  '_zcyl._djdkhb': "Appuyez pour ouvrir l'enveloppe rouge",
  '_zcyl._zclj': "Prime d'inscription",
  '_zcyl._hmyzh': 'Pas encore de compte ?',
  '_zcyl._qzc': "S'inscrire",
  '_zcyl._qxdjhb': "Veuillez d'abord réclamer votre prime",
  '_zcyl._qwzc': "Aller à l'inscription",
  '_zcyl._hbysy': 'Prime déjà utilisée',

  '_ggtg._qhz': 'Aller au Transfert',
  '_ggtg._dqye': 'Solde Actuel',
  '_ggtg._qcz': 'Aller au Dépôt',
  '_ggtg._hzje': 'Montant du Transfert',
  '_ggtg._ljhz': 'Transférer Maintenant',
  '_ggtg._yebz': 'Solde Insuffisant',

  '_sq._bhbt': 'Rejeté',

  '_sq._bhyy': 'Motif du refus',

  '_xx._ntq': 'Il y a {n} jours',

  '_xx._nxsq': 'Il y a {n} heures',

  '_xx._nfzq': 'Il y a {n} minutes',

  '_xx._nggq': "À l'instant",

  '_xx._djckgd': "Cliquez pour afficher plus d'informations",

  '_ct._zt': 'Statut',

  '_ct._ljz': 'Connexion en cours',

  '_ct._ylj': 'Connecté',

  '_ct._ltlieb': 'Liste de discussions',

  '_ct._bnhzj': 'Impossible de discuter avec moi-même',

  '_ct._cylb': 'Liste des membres',

  '_hb._fhb': 'Enveloppe rouge',

  '_hb._dqye': 'Solde actuel',

  '_hb._fsd': 'Destinataire',

  '_hb._hbje': "Montant de l'enveloppe rouge",

  '_hb._qshuru': "Veuillez saisir le montant de l'enveloppe rouge",

  '_hb._ljfs': "Envoyer' Maintenant",

  '_hb._hbz': "Bénédiction de l'enveloppe rouge",

  '_hb._qshuruzhu': 'Veuillez saisir votre bénédiction',

  '_sp._cuow': 'Les épisodes 1 à 10 doivent être débloqués avant de pouvoir être visionnés',

  '_bq._tzzq': "Période d'investissement",

  '_bq._zrsy': 'Bénéfice de la veille',

  '_bq._bqtz': "Investissement en droits d'auteur",

  '_bq._tzdj': "Montant de l'investissement",

  '_bq._zfjz': 'Le paiement doit être effectué dans les 24 heures, sinon il sera considéré comme annulé !',

  '_bq._qzf': 'Effectuer le paiement',

  '_bq.jz': 'Date limite',

  '_bq._ljzf': 'Payer maintenant',

  '_bq._sqbz': "Notes relatives à l'application (facultatif)",

  '_bq._sqbzsm': "Veuillez saisir les notes relatives à l'application",

  '_bq._zzsqz': "Demande de droit d'auteur en cours, en attente d'examen... ",

  '_app._xz': "Télécharger l'application ReelShortBiz",

  '_app._smerm': 'Scanner le code QR pour télécharger',

  '_app._xzbt': 'Télécharger',

  '_m._yhzz': 'Virement bancaire',
  '_m._yhxx': 'Informations bancaires',
  '_m._yhmz': 'Nom de la banque',
  '_m._yhdz': 'Adresse de la banque',
  '_m._yhmc': 'Nom',
  '_m._yhzh': 'Compte',
  '_m._yhlx': 'Type',
  '_m._yhly': 'Routing',
  '_m._yhdm': 'Code',
  '_m._yhbz': 'Note',
  '_m._fzxx': 'Copier les infos',

  '_m._zts': 'Conseils',

  '_m._zyd1': '1. Veuillez vérifier attentivement le nom du destinataire, son numéro de compte et le code bancaire lors du virement. Toute erreur peut entraîner la perte du transfert.',

  '_m._zyd2': "2. Il est recommandé de sélectionner l'option « L'émetteur prend en charge tous les frais » afin d'éviter les frais de virement insuffisants dus aux prélèvements bancaires intermédiaires.",

  '_m._zyd3': '3. Les virements prennent généralement entre 1 et 3 jours ouvrables. Merci de votre patience. Pour toute question, veuillez contacter le service client.',

  '_m._zyd4': '4. Pour toute autre question, veuillez contacter le service client.',

  '_m._jyh': 'Numéro de transaction',

  '_m._jyje': 'Montant',

  '_sp._dbye': 'Solde VOD',
  '_sp.hzye': 'Transfert',
  '_sp._txje': 'Montant du transfert',
  '_sp._qsrtxje': 'Veuillez saisir le montant du transfert',
  '_sp._ljhz': 'Transférer maintenant',
  '_sp._yebz': 'Solde insuffisant',
  '_sp._qshuru': 'Veuillez saisir le montant correct du transfert',
  '_sp._fanh': 'Retour',

  '_sp._tliu': 'Diffusion publicitaire',
  '_sp._xzgj': 'Sélectionner le pays',
  '_sp._cdcw': "Erreur d'encodage vidéo",
  '_ggtf._hot': 'Tendance',
  '_tl._tlsj': 'Heure de diffusion',
  '_tl._xzxb': 'Sélectionner le sexe',
  '_tl._nan': 'Homme',
  '_tl._nv': 'Femme',
  '_tl._hunhe': 'Mixte',
  '_tl._xznl': "Sélectionner l'âge",
  '_sp._us': 'États-Unis',
  '_sp._en': 'Royaume-Uni',
  '_sp._jp': 'Japon',
  '_sp._fr': 'France',
  '_sp._kr': 'Corée du Sud',
  '_sp._de': 'Allemagne',
  '_sp._id': 'Inde',
  '_sp._in': 'Indonésie',
  '_sp._au': 'Australie',
  '_sp._es': 'Espagne',
  '_sp._my': 'Malaisie',
  '_sp._cn': 'Chine',
  '_ggtf._fanhui': 'Retour',
  '_ggtf._jymmts': 'Veuillez confirmer le montant de la transaction et entrer votre mot de passe',
  '_wdtg._wjl_desc': "Vous n'avez participé à aucune campagne publicitaire",
  '_wd._jxz': 'En cours',
  '_wd._djs': 'En attente de règlement',
  '_wd._ywc': 'Terminé',
  '_wd._jz': 'Urgent',
  '_wd._hz': 'Virement',

  '_tl._tlfbqk': 'Répartition des dépenses publicitaires',
  '_tl._tlfbqk_desc': 'Jours 1-5: 5% (Phase de démarrage à froid), Jours 6-10: 20% (Phase de validation du contenu), Jours 11-15: 40% (Phase de construction IP), Jours 16-20: 35% (Phase de matrice de mini-séries)',

  '_nhz._sm': 'Après le transfert, le montant sera transféré sur le portefeuille vidéo pour débloquer le contenu vidéo',
  '_nhz._zhzz': 'Transfert en cours...',
  '_nhz._zzcg': 'Transfert réussi',
  '_nhz._zhzsb': 'Échec du transfert, veuillez réessayer',
  '_m._fzcg': 'Copié avec succès',
  '_m._fzsb': 'Échec de la copie, veuillez copier manuellement',
  '_m._zwfzxx': 'Aucune information à copier',
  '_tx._qb': 'Tous',
  'activity.detail': "Détails de l'activité",
  'activity.noDesc': "Aucune description de l'activité",
  'activity.desc': "Description de l'activité",
  'activity.requirements': 'Conditions de participation',
  'activity.minInvest': 'Investissement minimum',
  'activity.vipLevel': 'Niveau VIP',
  'activity.avgParticipation': 'Participation moyenne',
  'activity.avgParticipationDesc': 'fois',
  'activity.country': 'Sélectionner le pays',
  'activity.deliveryTime': 'Temps de diffusion',
  'activity.deliveryTimeDesc': 'jours',
  'activity.gender': 'Sélectionner le genre',
  'activity.male': 'Masculin',
  'activity.female': 'Féminin',
  'activity.mixed': 'Mixte',
  'activity.age': "Sélectionner l'âge",
  'activity.amount': "Montant d'achat",
  'activity.back': 'Retour',
  'activity.join': 'Participer maintenant',
  emptyData: 'Aucune donnée',
  emptyDataDesc: 'Aucune campagne publicitaire participante',
  completedtlement: 'Expiré',
  preheat: 'Préchauffage',
  progress: 'En cours',
  settlement: 'En attente de règlement',
  transfered: 'Transféré',
  completed: 'Terminé',
  activityCode: "Code d'activité",
  touzAmount: "Montant d'investissement",
  activityDays: "Jours d'activité",
  joinTime: 'Heure de participation',
  playSource: 'Distribution des sources de lecture',
  allPlatforms: 'Toutes les plateformes',
  other: 'Autre',
  totalPlayNum: 'Nombre total de lectures',
  incomeSummary: 'Résumé des revenus',
  totalPay: "Frais de droits d'auteur payés",
  totalIncome: 'Revenu total',
  copyrightRatio: 'Part du titulaire des droits',
  promotionIncome: 'Revenus de promotion',
  copyrightIncome: "Part des droits d'auteur",
  playNum: 'Lectures',
  buyNum: 'Lectures à la demande',
  incomeRate: 'Taux de partage',
  yjIncome: 'Revenu estimé',
  paid: 'Payé',
  timeout: 'Délai expiré',
  transfer: 'Transférer maintenant',
  loading: 'Chargement...',
  loadMore: 'Charger plus',
  noMore: 'Pas plus',
  nightTime: 'Période nocturne',
  morningTime: 'Période matinale',
  afternoonTime: "Période de l'après-midi",
  eveningTime: 'Période du soir',
  '_h._tc': 'Déconnexion',
  periodPayment: 'Paiement par période',
  periodPaymentDesc: "Le règlement a lieu 4 fois par jour en 4 périodes, vous pouvez payer les frais de droits d'auteur par période",

  day: 'jour',
  '_dl._hy': 'Bon retour',
  '_dl._cj': 'Créer un compte',
  '_dl._zmm': 'Réinitialiser le mot de passe',
  '_dl._hyDesc': 'Connectez-vous à votre compte pour continuer à explorer du contenu exceptionnel',
  '_dl._cjDesc': 'Rejoignez ReelShortBiz et commencez votre voyage passionnant',
  '_dl._zmmDesc': 'Entrez votre email et nous vous enverrons un code de vérification pour réinitialiser',
  '_dl._hlgqsp': 'Vaste bibliothèque de films et vidéos HD',
  '_dl._gxhty': 'Algorithmes de recommandation personnalisés',
  '_dl._ffddsp': 'Vidéos courtes variées',
  '_dl._dlzh': 'Se connecter',
  '_dl._sdndyx': 'Entrez votre email et mot de passe pour continuer',
  '_dl._email': 'Adresse email',
  '_dl._qsryx': 'Veuillez entrer votre adresse email',
  '_dl._dlmm': 'Mot de passe',
  '_dl._qsrmm': 'Veuillez entrer votre mot de passe',
  '_dl._wjmm': 'Mot de passe oublié ?',
  '_dl._immdl': 'Se connecter maintenant',
  '_dl._hmyzh2': "Vous n'avez pas de compte ?",
  '_dl._ljzc2': "S'inscrire maintenant",
  '_dl._cjzh': 'Créer un compte',
  '_dl._jswmd': 'Rejoignez ReelShortBiz et commencez votre voyage passionnant',
  '_zh._qszmm': 'Veuillez définir votre mot de passe',
  '_zh._qrmm': 'Confirmer le mot de passe',
  '_zh._qmm': 'Veuillez ressaisir le mot de passe',
  '_zc._yqm': "Code d'invitation",
  '_zc._sryqm': "Veuillez entrer le code d'invitation",
  '_dl._yzm': 'Code de vérification',
  '_dl._qsryzm': 'Veuillez entrer le code de vérification',
  '_dl._yjyzh': 'Vous avez déjà un compte ?',
  '_dl._zcbsty2': 'En vous inscrivant, vous acceptez',
  '_dl._zcbstyDesc': 'Politique de confidentialité',
  '_dl._newmm': 'Nouveau mot de passe',
  '_dl._qszxmm': 'Veuillez définir un nouveau mot de passe',
  '_dl._qrmm': 'Confirmer le mot de passe',
  '_dl._qzcsrmm': 'Veuillez ressaisir le nouveau mot de passe',
  '_dl._czmm': 'Réinitialiser le mot de passe',
  '_dl._xqlmm': 'Vous avez retrouvé votre mot de passe ?',
  '_dl._fhdl': 'Retour à la connexion',
  '_dl._srdllmmbyz': 'Les mots de passe ne correspondent pas',
  '_dl._czcg': 'Mot de passe réinitialisé avec succès',
  '_h._zc': "S'inscrire",
  // '_ybp._wdsy': 'Mes revenus',
  '_ybp._jrsy': "Revenus d'aujourd'hui",
  '_ybp._jztr': 'Par rapport à hier',
  '_ybp._bfl': 'Vues',
  '_ybp._dbl': 'Demandes',
  '_ybp._syqs': 'Tendance des revenus',
  // '_ybp._jr': 'Aujourd\'hui',
  '_ybp._t': 'jour',
  // '_ybp._dqye': 'Solde du compte',
  '_ybp._djs': 'En attente de règlement',
  '_ybp._zhl': 'Taux de conversion',
  '_ybp._sjgl': 'Aperçu des données',
  '_ybp._zrsy': "Revenus d'hier",
  '_ybp._bysy': 'Revenus de ce mois',
  '_ybp._yysj': 'Données opérationnelles',
  '_ybp._zr': 'Hier',
  '_ybp._zjfrs': 'Utilisateurs payants totaux',
  '_ybp._mtdqje': 'Montant dû demain',
  '_ybp._jsy': 'Revenus nets',
  '_ybp._bqfy': "Plan de paiement des droits d'auteur",
  '_ybp._yzf': 'Payé',
  '_ybp._qzf': 'Aller payer',
  '_ybp._bqfyts': "Après paiement des droits d'auteur, vos revenus et droits seront priorisés",
  '_ybp._syjl': 'Historique des revenus',
  '_ybp._ckgd': 'Voir plus',
  '_ybp._ssdt': 'Mises à jour en direct',
  '_ybp._bzzx': "Centre d'aide",
  '_ybp._lxkf': 'Contacter le support',
  '_ybp._zrxz': "Revenus d'hier",
  '_ybp._zdsy': 'Revenus totaux',
  '_ybp._qygy': 'Mois dernier',
  '_ybp._jsjl': 'Historique des règlements',
  '_ybp._hzjl': 'Historique des transferts',
  '_ybp._jfzq': 'il y a quelques minutes',
  '_ybp._fzq': 'il y a quelques heures',
  '_ybp._djs_mt': 'Montant du règlement demain',
  '_yj._rule': 'Règles de la plateforme',

  '_bq._jjks': 'Commencer maintenant',
  '_bq._jxz': 'En cours',
  '_bq._jks': 'Temps avant le début',
  '_bq._jjs': 'Temps avant la fin',
  '_bq._t': 'j',
  '_bq._h': 'h',
  '_bq._m': 'min',
  '_bq._s': 's',
  '_bq._kssj': 'Heure de début',
  '_bq._jssj': 'Heure de fin',
  '_bqq._tzdj': 'Prix unitaire',
  '_bqq._hdts': "Durée de l'événement",
  '_bqq._vip': 'Niveau VIP',
  '_bqq._rjcy': 'Participation moyenne',
  '_bqq._cs': 'fois',
  '_bqq._ysjd': 'Progression des ventes',
  '_bqq._ljqg': 'Acheter maintenant',
  '_bqq._zbkqg': 'Actuellement indisponible',
  '_bqq._jzz': 'Chargement',
  '_bqq._jzgd': 'Charger plus',
  '_bqq._wz': "Pas plus d'éléments",

  '_sp._gdsj': 'Total {n} épisodes',
  '_sy._jl': 'Enregistrement des règlements en attente',
  '_ybp._zsy': 'Revenu total',
  '_ybp._djsjl': 'Enregistrement des règlements en attente',
  '_ybp._bqbm': 'Code',
  '_ybp._je': 'Montant',
  '_ybp._sj': 'Heure',
  '_sy._djs': 'En attente',
  '_sy._yjs': 'Réglé',
  '_sy._gdstjl': 'Total {n} enregistrements',
  '_sy._gjd': 'Total {n}',

  '_sp.tgdy':'Le montant ne peut pas être inférieur à {a}',
  '_sp.tggy':'Le montant ne peut pas être supérieur à {a}',

  '_tg._zdyje': 'Montant personnalisé'
}
